<template>
  <icon-dropdown icon='ellipsis-v' class='accordion-collapser'>
    <li @click.stop="$root.$emit('collapseAll')">
      Collapse All
    </li>
    <li @click.stop="$root.$emit('expandAll')">
      Expand All
    </li>
  </icon-dropdown>
</template>

<script>
  import IconDropdown from '@atoms/IconDropdown'

  export default {
    components: {
      IconDropdown
    }
  }
</script>
